import { render, staticRenderFns } from "./MessageDetailsDialog.vue?vue&type=template&id=3414d198&scoped=true"
import script from "./MessageDetailsDialog.vue?vue&type=script&lang=js"
export * from "./MessageDetailsDialog.vue?vue&type=script&lang=js"
import style0 from "./MessageDetailsDialog.vue?vue&type=style&index=0&id=3414d198&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3414d198",
  null
  
)

export default component.exports